(($) => {
    $(document).ready(function() {
        if ($('.scrolling_jackpots').length < 1) return

        let exacta_codes = $('input[name="exacta-code"]'),
            jackpotTotalDate = $('#jackpot-total-date'),
            jackpotTotalAmount = $('#jackpot-total-amount')

        if (exacta_codes.length < 1) return

        let min_jackpot_value = $('input[name="minimum-jackpot-value"]')
        if (min_jackpot_value.length < 1) return

        let minimum_jackpot_value = parseInt(min_jackpot_value.val())
        if (isNaN(minimum_jackpot_value)) minimum_jackpot_value = 0

        let ONE_DAY_MS = 1000 * 60 * 60 * 24,
            THREE_DAYS_MS = ONE_DAY_MS * 3,
            jackpotMemo = [],
            jackpotTotals = 0,
            today = new Date(),
            yesterday = new Date()

        yesterday.setDate(yesterday.getDate() - 1)

        if (jackpotTotalDate.length > 0 && today.getHours() >= 2) {
            jackpotTotalDate.html(getMonthName(today) + ' ' + today.getDate() + ', ' + today.getFullYear())
        } else {
            jackpotTotalDate.html(getMonthName(yesterday) + ' ' + yesterday.getDate() + ', ' + yesterday.getFullYear())
        }

        function parseJackpots(d) {
            let ts, rawamount, amount, time, date = null

            for (let i = 0; i < d.length; i++) {
                rawamount = d[i]['Amount']/1000000
                if (rawamount < minimum_jackpot_value) continue

                ts = new Date(d[i]['Timestamp'])
                if ((today - ts) > THREE_DAYS_MS) continue

                amount = parseInt((Math.round(rawamount * 100) / 100).toFixed(0)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                time = formatAMPM(ts)
                date = (ts.getMonth() + 1) + "/" + ts.getDate() + "/" + ts.getFullYear()

                if (!jackpotMemo.includes(amount+time+date)) {
                    // if new Date().getHours() > 2 then
                    // tally up all jackpots for current day
                    // else tally up all jackpots for previous day

                    if (jackpotTotalAmount.length > 0
                        && (
                            today.getHours() >= 2 && ts.getDate() === today.getDate())
                            || (today.getHours() < 2 && ts.getDate() === yesterday.getDate()
                        )
                    ) {
                        jackpotTotals += rawamount
                        jackpotTotalAmount.html('$'+parseInt((Math.round(jackpotTotals * 100) / 100).toFixed(0)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                    }

                    jackpotMemo.push(amount+time+date)

                    $('.marquee-inner').attr('style', 'animation-duration: calc('+jackpotMemo.length+' * var(--marquee-animation-duration))')
                    $('.marquee-inner > div').append('<span class="jackpot-separator">&nbsp;•&nbsp;</span><span class="jackpot-amount"><span class="jackpot-dollar">$</span>'+amount+'</span>&nbsp;<span class="jackpot-text">JACKPOT</span>&nbsp;<span class="jackpot-time">'+time+'</span>')
                }
            }
        }

        for (let i = 0; i < exacta_codes.length; i++) {
            EI.jackpots(exacta_codes[i].value,100, parseJackpots)
        }

        function formatAMPM(date) {
            let hours = date.getHours()
            let minutes = date.getMinutes()
            let ampm = hours >= 12 ? 'PM' : 'AM'
            hours = hours % 12
            hours = hours ? hours : 12 // 0 == 12
            minutes = minutes < 10 ? '0'+minutes : minutes
            return hours + ':' + minutes + ' ' + ampm
        }

        function getMonthName(date) {
            return [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ][date.getMonth()]
        }
    })
})(jQuery)